import validate from 'validate.js';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const validateLightingForm = ({
  lighting_description = ''
}) => {
  if ('' !== lighting_description) {
    return {
      lighting_description: validate.single(lighting_description,
        {
          length: {
            minimum: 35,
            tooShort: (<FormattedMessage id="hosting.validate_lighting_form.min_character_message" defaultMessage="Enter at least 35 characters" />)
          }
        })
    };
  }
};

export default validateLightingForm;
